import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./gridItem.html";
export let GridItemBumps = /*#__PURE__*/function (GridItemBumps) {
  GridItemBumps["Top"] = "top";
  GridItemBumps["Right"] = "right";
  GridItemBumps["Bottom"] = "bottom";
  GridItemBumps["Left"] = "left";
  return GridItemBumps;
}({});
export let GridAligns = /*#__PURE__*/function (GridAligns) {
  GridAligns["Start"] = "start";
  GridAligns["End"] = "end";
  GridAligns["Center"] = "center";
  GridAligns["Stretch"] = "stretch";
  return GridAligns;
}({});
class GridItem extends LightningElement {
  set gridItemSize(value) {
    this.setAttribute('size', value);
  }
  get gridItemSize() {
    return this.getAttribute('size');
  }
  set gridItemBump(value) {
    this.setAttribute('bump', value);
  }
  get gridItemBump() {
    return this.getAttribute('bump');
  }
  set gridItemAlign(value) {
    this.setAttribute('align', value);
  }
  get gridItemAlign() {
    return this.getAttribute('align');
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(GridItem, {
  publicProps: {
    gridItemSize: {
      config: 3
    },
    gridItemBump: {
      config: 3
    },
    gridItemAlign: {
      config: 3
    }
  }
});
const __lwc_component_class_internal = _registerComponent(GridItem, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;